<template>
  <div class="home">
    <!--    <pc-header />-->
    <div class="page-content" :class="{'test-top':$bus.params.isTest&&!$bus.params.noTip}" style="padding-bottom: 38px">
      <div v-if="$bus.isStart && !$bus.isEnd">
        <div class="progress-wrapper" :class="{'progress-wrapper-add-bottom':$bus.params.isTest&&!$bus.params.noTip}" v-if="showProgress">
          <el-progress :percentage="percent" />
        </div>
        <div
          class="text-yellow-theme text-medium flex items-center justify-center"
          style="height: 32px;background: #FFFCEB;font-weight: 500; position: fixed; top: 18px;left: 0;right: 0;z-index: 100;"
          v-if="$bus.params.isTest&&!$bus.params.noTip"
        >
          当前为电脑模拟答题，提交的答卷不会保存
        </div>
        <div class="text-center mt-1 mb-2" v-if="maxAnswerTime > 0">
          <span>当前答题时间剩余</span>
          <span class="ml-2" :class="{ 'text-red': maxAnswerTime <= 10 }">{{ remainingTime }}</span>
        </div>
        <div class="text-center mt-1 mb-2" v-if="maxPageAnswerTime > 0">
          <span>当前页答题时间剩余</span>
          <span class="ml-2" :class="{ 'text-red': maxPageAnswerTime <= 10 }">{{ maxPageTime }}</span>
        </div>
      </div>

      <template v-if="$bus.isSurveyLoad">
        <template v-if="!$bus.isStart && !$bus.isEnd">
          <pc-info />
        </template>
        <template v-else-if="$bus.isStart && !$bus.isEnd">
          <template v-if="themeHeaderShow">
            <!-- <div class="px-4 base-width">
              <img :src="themeHeaderImage" alt="" class="max-w-full" />
            </div> -->
            <DisplayHeader :themeHeader="themeHeader"  :class="baseClass"></DisplayHeader>
          </template>
          <template v-if="showPureHeader">
            <div class="survey-info" :class="baseClass">
              <award-notice-wrapper/>
              <survey-info />
            </div>
          </template>
          <div class="question-group" :class="baseClass">
            <template v-if="showPreview">
              <div v-for="question in $bus.pageList" :key="question.q_id" class="relative">
                <preview-question :enable-question-index="enableQuestionIndex" :question="question" />
                <div v-if="!notMaskTypes.includes(question.questionType)" class="absolute inset-0 z-50"></div>
              </div>
            </template>
            <template v-else>
              <template v-if="enabledVoteViewSurvey">
               <div class="w-full px-10 box-border bg-white">
                 <vote-answer-question
                     class="cursor-pointer mb-4 last:mb-0"
                     v-for="question in $bus.pageList"
                     :key="question.q_id"
                     :question="question"
                     :enable-question-index="enableQuestionIndex"
                 />
               </div>
              </template>
              <template v-else>
                <question-item
                    v-for="question in $bus.pageList"
                    :key="question.q_id"
                    :question="question"
                    :enable-question-index="enableQuestionIndex"
                />
              </template>
            </template>
          </div>
          <div v-if="!disableSubmit" class="text-center bg-white pb-6 pt-10" :style="buttonWrapStyle" :class="baseClass">
            <el-button v-if="showPreBtn" type="primary" :loading="loading" :disabled="loading" @click="$bus.showPrevPage">
              {{ buttonOption.prevText }}
            </el-button>
            <el-button
              :disabled="loading || nextPageBtnDisabled || submitBtnDisabled"
              type="primary"
              @click="$bus.submitOrNextPage"
            >
              <template v-if="minSubmitAnswerTimer > 0 && (!isSofgPageStart || isLastPage)"> {{ minSubmitAnswerTimer }}秒后继续</template>
              <span v-else>{{ (isLastPage&&!isSoftPage) ? buttonOption.submitText : buttonOption.nextText }}</span>
            </el-button>
          </div>
          <!-- 网站协议文案提示 -->
          <DygcFooter class="my-2" v-if="isDygcFooter"/>
        </template>
        <template v-else-if="$bus.isEnd">
          <pc-end />
        </template>
      </template>
      <v-code :show="showVerification" @success="$bus.onVerificationSuccess" @close="$bus.onVerificationClose" />
    </div>
  </div>
</template>

<script>
import { normalizeUrlParams, getSurvey, busGetters, formatSeconds, createStyle, questionType, getSurveyPoint, getStatusConfig,sendMessage } from 'dygc'
import PcHeader from '@/components/PcHeader'
import PcInfo from '@/components/PcInfo'
import QuestionItem from '@/components/QuestionItem'
import PcEnd from '@/components/PcEnd'
import SurveyInfo from '@/components/SurveyInfo'
import VCode from 'vue-puzzle-vcode'
import AwardNotice from '@/components/AwardNotice'
import PreviewQuestion from '@/components/PreviewQuestion'
import DygcFooter from 'components/dygc-footer-bottom/index'
import DisplayHeader from '@/components/DisplayHeader'
import AwardNoticeWrapper from '@/components/reward/AwardNoticeWrapper.vue'
import VoteAnswerQuestion from '@/components/VoteAnswerQuestion.vue'
import { createPopup, closeAllOverlay } from '@/assets/js/factory'
import OverlayError from '@/components/overlay/OverlayError.vue'

export default {
  name: 'Home',
  data() {
    return {
      notMaskTypes: [
        questionType.MATRIX_SCALE,
        questionType.MATRIX_SINGLE_CHOICE,
        questionType.MATRIX_MULTIPLE_CHOICE,
        questionType.CUSTOM_MULTIPLE_SCALE,
        questionType.MATRIX_FILL,
        questionType.MATRIX_SELECT_CHOICE,
        questionType.MATRIX_AUTO,
        questionType.MATRIX_COMPOSE
      ],
      viewStatus: true,
      footerStatus: true,
      footerStatusPreview: true
    }
  },
  created() {
    // 答完题 查看内容 点击浏览器返回 不需要任何操作 就显示离开之前的页面即可
    if(this.$bus.answerId && this.$bus.isEnd) return
    const params = normalizeUrlParams()
    if (!params.surveyId) {
      if (!params.lazy) {
        createPopup(OverlayError, {}, {})
      } else {
        sendMessage({
          message: 'pageLoad',
          payload: {}
        })
      }
      return
    }
    this.initSurvey(params)
      // 答题换壳
  },
  components: {
    VoteAnswerQuestion,
    AwardNoticeWrapper,
    PreviewQuestion,
    AwardNotice,
    SurveyInfo,
    PcEnd,
    QuestionItem,
    PcInfo,
    PcHeader,
    DygcFooter,
    DisplayHeader,
    VCode: {
      extends: VCode,
      methods: {
        onClose() {}
      }
    }
  },
  computed: {
    baseClass(){
      return this.isBaseWidth ? 'base-width': ''
    },
    isBaseWidth(){
      return !this.$bus.params.fullWidth
    },
    enabledVoteViewSurvey(){
      return this.$bus.survey.otherSetting.enabledVoteViewSurvey
    },
    showProgress(){
      return this.$bus.survey.otherSetting.progressStatus !==0
    },
    enableQuestionIndex() {
      return this.$bus.enableQuestionIndex
    },
    disableSubmit() {
      return this.$bus.params.disableSubmit
    },
    buttonWrapStyle() {
      if (this.$bus.params.isTest) {
        return {
          paddingBottom: '100px'
        }
      } else {
        return {}
      }
    },
    themeHeaderImage() {
      const themeHeader = this.themeHeader
      if (!themeHeader) return
      if (!themeHeader.show || !themeHeader.image) return
      return window.location.origin + '/fill/api/v1/download?fileName=' + themeHeader.image
    },
    themeHeaderShow() {
      const themeHeader = this.themeHeader
      if (!themeHeader) return true
      if (themeHeader.show && ((!themeHeader.type) || (themeHeader.type=='image'&&!themeHeader.image))) return true
      if (!themeHeader.show || (!themeHeader.image && themeHeader.image!='none' && !themeHeader.text && themeHeader.carouselImageList?.length==0)) return false
      return true
    },
    remainingTime() {
      return formatSeconds(this.maxAnswerTime)
    },
    maxPageTime() {
      return formatSeconds(this.maxPageAnswerTime)
    },
    showPreBtn() {
      return this.enablePrePage && this.currentPageNum
    },
    showPureHeader() {
      return !this.enableHomePage && this.currentPageNum === 0
    },
    minSubmitAnswerTimer() {
      if (this.isLastPage) {
        const minAnswerTime = this.minAnswerTime
        const minPageAnswerTime = this.minPageAnswerTime
        if (minAnswerTime && minPageAnswerTime) {
          return Math.max(minPageAnswerTime, minAnswerTime)
        } else if (minAnswerTime) {
          return minAnswerTime
        } else {
          return minPageAnswerTime
        }
      } else {
        return this.minPageAnswerTime
      }
    },
    submitBtnDisabled() {
      if (this.isLastPage) {
        return this.minAnswerTime > 0
      } else {
        return false
      }
    },
    isDygcFooter() {
      if(this.$bus.params.isTest === 'true') {
        return this.footerStatusPreview
      }
      return this.footerStatus
    },
    ...busGetters([
      'percent',
      'isLastPage',
      'isSoftPage',
      'isStart',
      'isEnd',
      'showVerification',
      'maxAnswerTime',
      'minAnswerTime',
      'nextPageBtnDisabled',
      'minPageAnswerTime',
      'maxPageAnswerTime',
      'enableHomePage',
      'currentPageNum',
      'loading',
      'enablePrePage',
      'buttonOption',
      'showPreview',
      'isSofgPageStart'
    ])
  },
  methods: {
    initSurvey(params){
      this.$bus.openLoading()
      getSurvey(params)
        .then(res => {
          if (res.channel && (res.channel.channelType || '').toString() === '2') {
            return getSurveyPoint(params.surveyId)
              .then(surveyPoint => {
                this.$bus.init(Object.assign({}, res, { ...params, surveyPoint }))
              })
              .catch(() => {
                this.$bus.init(Object.assign({}, res, { ...params }))
              })
          } else {
            this.$bus.init(Object.assign({}, res), params)
          }
        })
        .then(()=>{
          this.getCompanyStyle(this.$bus.survey.companyId)
        })
        .catch(this.$bus.initError)
    },
    getCompanyStyle(companyid){
      getStatusConfig(companyid, ["out_D55", "out_D55_D", "wj_F77"]).then(res => {
        if(res?.code !== 0) return
        this.viewStatus = res.data.out_D55 === "1"
        this.footerStatus = res.data.out_D55_D === "1"
        this.footerStatusPreview = res.data.wj_F77 === "1"
      })
    },
    initHooks() {
      const bus = this.$bus
      let hook = bus.hook
      hook.on('surveyLoad', () => {
        let otherSetting = bus.survey.otherSetting || {}
        this.themeHeader = otherSetting.themeHeader
        const background = otherSetting.background
        if (background) {
          createStyle({
            background: background
          })
        }
      })
      if (bus.params.isTest) {
        window.addEventListener('message', event => {
          let data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data
          if (data.message !== 'CHANGE_THEME') return
          let otherSetting = bus.survey.otherSetting || {}
          const d = data.payload
          const background = (otherSetting.background = Object.assign({}, otherSetting.background || {}, d.background || {}))
          this.themeHeader = otherSetting.themeHeader = Object.assign({}, otherSetting.themeHeader || {}, d.themeHeader || {})
          otherSetting.buttonOption = Object.assign({}, otherSetting.buttonOption || {}, d.buttonOption || {})
          bus.survey.otherSetting = Object.assign({}, otherSetting)
          this.$set(otherSetting, 'background', background)
          createStyle({
            background: background
          })
        })
      }
    }
  },
  mounted() {
    this.initHooks()
    window.addEventListener('message', ev => {
      if (typeof ev.data !== 'string') return
      if (!ev.data.startsWith('answerStart:')) {
        return
      }
      closeAllOverlay()
      const [, ...url] = ev.data.split(':')
      const params = normalizeUrlParams(false, url.join(':'))
      this.$bus.customStartData.id = null
      this.$bus.initial(params)
      this.initSurvey(params)
    })
  }
}
</script>
